<template>
  <div class="d-flex flex-column ga-4">
    <v-alert type="info">
      {{ $t("ncrm.workflows.nodeSettings.leadBoard.bestPractice") }}
    </v-alert>
    <v-row dense>
      <v-col cols="12" md="4">
        <v-switch v-model="form.status" :true-value="'active'" :false-value="'inactive'" color="primary" hide-details :label="$t('ncrm.workflows.nodeSettings.active')" />
      </v-col>
      <v-col cols="12" md="4">
        <v-switch v-model="form.autoRun" color="success" hide-details :label="$t('ncrm.workflows.nodeSettings.leadBoard.autoRun')" />
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-if="form.autoRun"
          v-model="form.autoRunIntervalMinutes"
          :items="intervalOptions"
          item-title="label"
          item-value="value"
          :label="$t('ncrm.workflows.nodeSettings.leadBoard.autoRunInterval')"
          hide-details="auto"
          :menu-props="selectMenuProps"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="6">
        <v-select
          v-model="form.boardId"
          :items="leadBoardOptions"
          item-title="label"
          item-value="value"
          :label="$t('ncrm.workflows.nodeSettings.leadBoard.board')"
          hide-details="auto"
          :loading="loadingLeadBoards"
          :menu-props="selectMenuProps"
          @update:model-value="$emit('fetch-lead-stages', $event)"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-model="form.stageId"
          :items="leadStageOptions"
          item-title="label"
          item-value="value"
          :label="$t('ncrm.workflows.nodeSettings.leadBoard.stage')"
          hide-details="auto"
          :loading="loadingLeadStages"
          :disabled="!form.boardId"
          :menu-props="selectMenuProps"
        />
      </v-col>
    </v-row>
    <v-alert v-if="leadBoardError" type="warning" density="compact">
      {{ leadBoardError }}
    </v-alert>
    <v-textarea
      v-model="form.description"
      :label="$t('ncrm.workflows.nodeSettings.description')"
      rows="3"
      hide-details="auto"
    />
  </div>
</template>

<script>
export default {
  name: "NcrmWorkflowLeadBoardSettings",
  props: {
    form: { type: Object, required: true },
    intervalOptions: { type: Array, default: () => [] },
    selectMenuProps: { type: Object, required: true },
    leadBoardOptions: { type: Array, default: () => [] },
    leadStageOptions: { type: Array, default: () => [] },
    loadingLeadBoards: { type: Boolean, default: false },
    loadingLeadStages: { type: Boolean, default: false },
    leadBoardError: { type: String, default: "" },
  },
  emits: ["fetch-lead-stages"],
};
</script>
